var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip2Vue',{attrs:{"position":_vm.position},scopedSlots:_vm._u([{key:"tooltip",fn:function(){return [_c('div',{staticClass:"tp-board"},[_vm._t("default",function(){return [_c('div',[_vm._v(" Prueba tooltip ")])]})],2)]},proxy:true}],null,true)},[_vm._t("button",function(){return [_c('TreeDots')]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }